import { LitElement, html } from 'lit';
import 'hls-video-element';
// eslint-disable-next-line
import styles from '!!lit-css-loader!postcss-loader!sass-loader!./MediaViewer.scss';

class TwitterVideo extends LitElement {
  static styles = [styles];

  static get properties() {
    return {
      src: { type: String },
      muted: { type: Boolean },
      playing: { type: Boolean },
      onVideoError: { type: Function },
    };
  }

  constructor() {
    super();
    this.hasError = false;
    this.player = null;
  }

  /**
   * Handles video errors including CORS issues with Twitter videos
   */
  handleVideoError = () => {
    // Critical point: Check if onVideoError callback exists before calling
    if (this.onVideoError && typeof this.onVideoError === 'function') {
      this.onVideoError({ target: this.player });
    } else {
      // Fallback: Mark component as having error for graceful degradation
      this.hasError = true;
      this.requestUpdate();
    }
  };

  firstUpdated() {
    this.player = this.shadowRoot.querySelector('#twitter-video-player');

    if (this.player) {
      // Critical point: Add error handling for CORS and loading issues
      this.player.addEventListener('error', this.handleVideoError);
      this.player.addEventListener('loadstart', () => {
        this.hasError = false;
      });
    }
  }

  /**
   * Cleanup when component is disconnected
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.player) {
      this.player.removeEventListener('error', this.handleVideoError);
    }
  }

  render() {
    const { src, muted } = this;

    // If there's an error, show error message
    if (this.hasError) {
      return html`<div class="media-viewer__video-error">Video unavailable</div>`;
    }

    return muted
      ? html`<video
          id="twitter-video-player"
          class="media-viewer__video"
          autoplay
          muted
          loop
          src=${src}
          preload="auto"
          playsinline
          crossorigin="anonymous"
        ></video>`
      : html`<video
          id="twitter-video-player"
          class="media-viewer__video"
          autoplay
          src=${src}
          controls
          preload="auto"
          playsinline
          crossorigin="anonymous"
        ></video>`;
  }
}

export default TwitterVideo;
